/* eslint-disable */
require('./bubble-left')
require('./bubble-right')
require('./bubble-shape')
require('./bubble')
require('./click-tip-shape')
require('./phone-frame-gray')
require('./phone-frame')
require('./poster-text-icon')
require('./qr-frame')
